<!--component for showing listed phrases on chat view-->
<template>
  <div class="flex justify-center">
    <div class="col-12 max-width-4 mx-auto my2 px3 center">
      <div class="border-top border-gray-4">
        <ListPhraseItem v-for="phrase in phrases" :phrase="phrase" :key="(phrase.company ? '##' : '#') + phrase.hashtag" :chat="chat"></ListPhraseItem>
      </div>
    </div>
  </div>
</template>

<script>
import ListPhraseItem from '@/components/reception/PhraseListItem.vue';
import { mapGetters } from "vuex";

export default {
  name: 'PhraseList',
  components: { ListPhraseItem },
  props: {
    chat: Object,
  },
  computed: {
    ...mapGetters({
        phrases: 'filteredPhrases',
    }),
},
}
</script>
